/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPaymentsQueryResponse, GetApiPaymentsQueryParams, GetApiPayments400, GetApiPayments403, GetApiPayments404, GetApiPayments500 } from "../entities/GetApiPayments";

function getGetApiPaymentsUrl() {
  const res = { method: 'GET', url: `/api/payments` as const }
  return res
}

/**
 * @description Возвращает текущий статус последнего платежа группы записей
 * @summary Получить статус оплаты
 * {@link /api/payments}
 */
export async function getApiPayments(params: GetApiPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiPaymentsQueryResponse, ResponseErrorConfig<GetApiPayments400 | GetApiPayments403 | GetApiPayments404 | GetApiPayments500>, unknown>({ method : "GET", url : getGetApiPaymentsUrl().url.toString(), params, ... requestConfig })
  return res.data
}